{
  "home": "Home",
  "reload": "Reload",
  "subtitle": "An unexpected error occurred while loading the page."
}
